// import "@babel/polyfill";
// import Vue from "vue";
// import { VueRouter } from "vue-router";
import { createWebHistory, createRouter } from "vue-router";

import axios from "axios";

// Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

const router = createRouter({
  history: createWebHistory(),
  // base: process.env.BASE_URL,
  base: "http://localhost:3580",
  routes,
});
// const router = new VueRouter({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes,
// });

axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.status === 401) {
      window.location = "/user/login";
    }
    return response;
  },
  function (error) {
    // Do something with response error
    if (error.response.status === 401) {
      window.location = "/logout";
    }
    return Promise.reject(error);
  }
);

export default router;
